const TestimonialRow = ({ item }) => (
    <>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.name}</td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.role}</td>
      <td className="px-6 py-4 text-sm text-gray-500">{item.feedback}</td>
    </>
  );
  
  export default TestimonialRow;
  